import { FACT_NAMES_STRING } from '@trnsact/business-criteria';
import { determineNumberValue } from 'modules/jsonRulesCriterias/businessCriteria';
import { allStringFactsOptions } from '../constants';

export function mapCriteriaFormRulesToValue(formRules: Record<string, any>[], dealerProfiles: any[] = []) {
  if (!Array.isArray(formRules)) return [];

  return formRules.map(rule => {
    let stringValue = [];

    // Handle DEALERS fact type separately with dealer profiles
    if (rule.fact === FACT_NAMES_STRING.DEALERS && Array.isArray(rule?.exactMatch)) {
      stringValue = dealerProfiles
        .filter(profile => {
          // Add defensive checks to prevent runtime errors
          if (!profile) {
            console.warn('Invalid dealer profile structure:', profile);
            return false;
          }

          const vendorProfileId = profile.id;
          return vendorProfileId && rule.exactMatch.includes(vendorProfileId);
        })
        .map(profile => ({
          value: profile.id,
          label: profile.name?.replace('VP - ', '') || profile.name || 'Unknown Dealer',
          ...profile,
        }));
    } else if (Array.isArray(rule?.exactMatch)) {
      // Handle other string facts with predefined options
      stringValue = allStringFactsOptions.filter(({ value }) => rule.exactMatch.includes(value));
    }

    return {
      rule,
      fact: rule.fact,
      boolean: { value: rule?.value ?? false },
      number: {
        min: determineNumberValue(rule?.minValue ?? ''),
        max: determineNumberValue(rule?.maxValue ?? ''),
      },
      string: {
        value: stringValue,
      },
      isRequiredToQuote: rule?.requiredForQuote ?? false,
    };
  });
}
